import { getKeys as i } from "./getKeys.js";
function l(o, t, f, {
  delimiter: e = "-",
  breakpointFallback: n = "xxs",
  specValueMapper: s = (u) => typeof u != "object" ? `${u}` : ""
} = {}) {
  if (typeof t != "object") {
    const r = typeof t == "boolean", $ = r ? "" : `${e}${t}`;
    return r && t === !1 ? [""] : [`${o}${e}${n}${$}`];
  }
  const u = i(t);
  return n && u.indexOf(n) === -1 && u.unshift(n), u.map((r) => {
    const $ = typeof t[r] < "u" ? t[r] : f, y = typeof $ == "boolean", x = y ? "" : `${e}${s($)}`;
    return y && $ === !1 ? "" : `${o}${e}${r}${x}`;
  });
}
function S(o, t, f = "xxs") {
  if (typeof o != "object")
    return [`${f}-${o}`];
  const e = i(o);
  return e.indexOf(f) === -1 && e.unshift(f), e.map((n) => {
    const s = typeof o[n] < "u" ? o[n] : t;
    return `${n}-${s}`;
  });
}
function d(o, t) {
  return o.map((f) => t[f]);
}
export {
  l as createClassNameSelectors,
  S as createPureSelectors,
  d as getStylesFromSelectors
};
